import { polymorphicFactory, Typography } from '@kohler-dsm-library/kohler-core';
import clsx from 'clsx';
import React from 'react';
import classes from './NavigationItem.module.css.mjs';

const NavigationItem = polymorphicFactory((props, ref) => {
  const { component, text, isSelected = false, variant = "v2.1", className, ...rest } = props;
  const isUniversal = variant === "universal";
  return /* @__PURE__ */ React.createElement(
    Typography,
    {
      component: rest.href ? "a" : component || "span",
      ref,
      size: isSelected ? "navigation-selected" : "navigation-unselected",
      className: clsx(
        "kohler-navigation-item-root",
        classes.navigationItem,
        !isSelected && classes.navigationItemUnselected,
        isUniversal && classes.navigationItemUniversal,
        !isSelected && !isUniversal && classes.navigationItemDefault,
        isSelected && !isUniversal && classes.navigationItemSelectedDefault,
        isSelected && isUniversal && classes.navigationItemSelectedUniversal,
        className
      ),
      ...rest
    },
    text
  );
});

export { NavigationItem };
